export default __webpack_public_path__ + "static/giant-scheda-tecnica-f436d716f7c4d0e2b3e5b06e74c7a522.pdf";